import React from "react";
import { API_URL } from "../../constants/api";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  DCOP_SOURCE_SYSTEM,
  REQUEST_STATUS,
  SECTIONS,
  TOOLTIP_LABEL
} from "../../constants/appConstants";
import { setSPSToken, getSPSTokenData } from "../../constants/constants";
import uniqBy from "lodash/uniqBy";
import {
  IsSectionVisible,
  removeDuplicates,
  PaperComponent,
  sortArray,
  getToolTipText,
  IsAdmin,
  CheckPermission,
  GetEnableProperty
} from "../../utils/helper";
import {
  apiBatchRequest,
  apiDelete,
  apiRequest
} from "../../utils/api_service";
import DownloadSSRSPopUp from "../common/button-download-popup";
import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Toolbar,
  Typography,
  Tooltip
} from "@material-ui/core";
import "./security.less";
import AddUpdateIncident from "./addUpdateIncident";
import PaginationControlled from "../common/pagination/pagination";
import TableHeaderWithFilter from "../common/table-header-filter";
import { filterTableRows } from "../../utils/filtered";
import { getArrayIndex } from "../../utils/lodash";
import { downloadExcelReportByAPI } from "../../utils/downloading";
import { Security_Incident_List } from "../../constants/ssrs_api";
import { convertIntoDDFormat } from "../../utils/generic";
import moment from "moment";
import { IoMdCloseCircleOutline } from "react-icons/io";
import orderBy from "lodash/orderBy";
import FilterOff from "../../public/img/common/filterOff.svg";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ShowToast, toastType } from "../../utils/toast-service";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../common/Dailogbox/ConfirmDailog";

class SecurityIncidentTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editableData: "",
      isShowColFilter: true,
      isOpenAddUpdate: props.isOpenCreateRequest
        ? props.isOpenCreateRequest
        : false,
      pageNo: 0,
      urlIncidentId: "",
      rowsPerPagination: 25,
      colFilteredObj: [],
      sortByColKey: "incidentId",
      incidentList: [],
      title: "",
      getToolTip: [],
      reload: false,
      selectedSource: [],
      selectedIds: {},
      refreshFilteredObj: false,
      keepFilterData: false,
      clearData: false,
      sourceSystemMasterData: [],
      reasonForDelete: "",
      isOpenDeleteConfirmationPanel: false,
      notificationProps: props.notificationProps
    };
  }

  /**
   * fetch data from new props
   * @param {*} newProps
   * @param {*} state
   * @returns
   */
  static getDerivedStateFromProps(newProps, state) {
    if (
      newProps.notificationProps !== (state || {}).notificationProps ||
      newProps.notificationProps?.isReply !==
        (state || {}).notificationProps?.isReply ||
      newProps.notificationProps?.createdOn !==
        (state || {}).notificationProps?.createdOn ||
      newProps.notificationProps?.message !==
        (state || {}).notificationProps?.message ||
      newProps.notificationProps?.recordId !==
        (state || {}).notificationProps?.recordId
    ) {
      const data = (state?.incidentList || []).filter(
        x =>
          x.incidentId.toString() ===
          newProps.notificationProps?.recordId.toString()
      )[0] || { incidentId: newProps.notificationProps?.recordId };
      return {
        notificationProps: newProps.notificationProps,
        isOpenAddUpdate: newProps?.notificationProps ? true : false, //newProps.notificationProps?.isOpenRequest,
        editableData: newProps.notificationProps ? data : "",
        sortByColKey: "",
        clearData: false,
        message: newProps.notificationProps?.message,
        createdOn: newProps.notificationProps?.createdOn
      };
    } else {
      return state;
    }
  }

  /** Onload event */
  componentDidMount() {
    window.scrollTo(0, 0);
    const URLsearch = window.location.search;
    if (URLsearch && URLsearch.indexOf("incidentId") !== -1) {
      this.setState({
        urlIncidentId: atob(URLsearch.split("=")[1]),
        isOpenAddUpdate: true
      });
    }
    //fetch list data
    this.getMasterData();
    this.getTokenSpsData();
  }

  /** Reset Page */
  resetPage = () => {
    this.getIncidentList();
  };

  /** Get token Share point data */
  getTokenSpsData = () => {
    if (!getSPSTokenData()) {
      apiRequest({
        url: API_URL.getSPSToken,
        params: { isHideLoader: true }
      }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
        }
      });
    }
  };

  /**
   * get master data
   */
  getMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.securityIncident.getSecurityIncidentMasterData,
        key: "incidentMasterData"
      },
      {
        url: API_URL.securityIncident.getSecurityIncidentList,
        key: "incidentList",
        params: { DateOffset: moment().utcOffset() }
      },
      {
        url: API_URL.masterData.GetLabels,
        key: "getToolTip",
        params: { sectionId: SECTIONS.SECURITY_INCIDENT_CREATE }
      }
    ]).then(({ incidentMasterData, incidentList, getToolTip }) => {
      const categoryMasterData = incidentMasterData?.data
        .filter(x => x.Key === "Category")
        .map(y => {
          return {
            categoryTypeId: y.Value,
            categoryType: y.Label,
            id: y.Value,
            isDCOP: y.IsDCOP,
            isSharePoint: y.IsSharePoint,
            isActive: y.IsActive,
            ListOrderBy: y.ListOrderBy
          };
        });
      const subCategoryMasterData = incidentMasterData?.data
        .filter(x => x.Key === "SubCategory")
        .map(y => {
          return {
            SubCategoryId: y.Value,
            SubCategory: y.Label,
            id: y.Value,
            isDCOP: y.IsDCOP,
            isSharePoint: y.IsSharePoint,
            CategoryId: y.CategoryId,
            isActive: y.IsActive,
            ListOrderBy: y.ListOrderBy
          };
        });
      const contributingFactorMasterData = incidentMasterData?.data
        .filter(x => x.Key === "ContributingFactor")
        .map(y => {
          return {
            ContributingFactorId: y.Value,
            ContributingFactor: y.Label,
            id: y.Value,
            ListOrderBy: y.ListOrderBy
          };
        });

      const dataCenterMasterData = incidentMasterData?.data
        .filter(x => x.Key === "DataCenter")
        .map(y => {
          return {
            DataCenterId: y.Value,
            DataCenter: y.Label,
            id: y.Value,
            ListOrderBy: y.ListOrderBy
          };
        });

      const statusMasterData = incidentMasterData?.data
        .filter(x => x.Key === "IncidentStatus")
        .map(y => {
          return {
            IncidentStatusId: y.Value,
            IncidentStatus: y.Label,
            isActive: y.IsActive,
            ListOrderBy: y.ListOrderBy
          };
        });

      // fitter the source system master data
      const sourceSystemMasterData = incidentMasterData?.data
        .filter(x => x.Key === "SourceSystem")
        .map(y => {
          return {
            SourceSystemId: y.Value,
            SourceSystem: y.Label
          };
        });
      let filterIncidentList = incidentList?.data;
      if (this.isSpViewIconVisible() == false) {
        filterIncidentList = incidentList?.data.filter(
          x => x.sourceSystemId === DCOP_SOURCE_SYSTEM
        );
      }
      const { notificationProps } = this.state;
      if(notificationProps){
      const data =
        filterIncidentList.filter(
          x => x.incidentId.toString() === notificationProps.recordId.toString()
        )[0] || {};
      this.onEditClicked(true, data);
        }
      this.setState({
        incidentList: filterIncidentList,
        categoryMasterData,
        subCategoryMasterData,
        contributingFactorMasterData,
        dataCenterMasterData,
        statusMasterData,
        getToolTip: getToolTip?.data,
        sourceSystemMasterData
      });
    });
  };

  /**
   * get security incident list
   */
  getIncidentList = () => {
    const { notificationProps } = this.state;

    apiRequest({
      url: API_URL.securityIncident.getSecurityIncidentList,
      params: { DateOffset: moment().utcOffset() }
    }).then(({ data: List }) => {
      if (this.isSpViewIconVisible() == false) {
        List = List.filter(x => x.sourceSystemId === DCOP_SOURCE_SYSTEM);
      }
      this.setState({
        incidentList: List
      });

      if (notificationProps !== undefined) {
        const data =
          List.filter(
            x =>
              x.incidentId.toString() === notificationProps.recordId.toString()
          )[0] || {};
        this.onEditClicked(true, data);
      }
    });
  };

  /**
   * call on save button
   */
  onSave = () => {
    const { colFilteredObj, reload } = this.state;
    this.setState({
      isOpenAddUpdate: false,
      keepFilterData: true,
      reload: !reload,
      selectedSource: colFilteredObj,
      clearData: false
    });
    this.getIncidentList();
  };

  /**
   * call when click on edit icon
   * @param {*} isOpen
   * @param {*} editRow
   */
  onEditClicked = (isOpen = false, editRow = "") => {
    this.setState({
      isOpenAddUpdate: isOpen,
      editableData: editRow
    });
  };

  /**
   * call when create new record
   * @param {*} isOpen
   */
  onAddButtonClicked = (isOpen = false) => {
    this.setState({
      isOpenAddUpdate: isOpen,
      editableData: ""
    });
  };

  setStateVal = (key, value) => {
    this.setState({ [key]: value });
  };

  /**
   * call on cancel button
   * @param {*} isCalledGet
   */
  refreshIncident = (isCalledGet = true) => {
    const { reload, colFilteredObj } = this.state;
    this.clearSearchRequestId();

    this.setState({
      isOpenAddUpdate: false,
      editableData: "",
      keepFilterData: true,
      reload: !reload,
      selectedSource: colFilteredObj,
      clearData: false
    });
    isCalledGet && this.getIncidentList();
  };

  /**
   * call on page selection
   * @param {*} pageNo
   * @param {*} rowsPerPagination
   */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  };

  /** Clear Search from requested Id */
  clearSearchRequestId = () => {
    this.props.history.replace({
      search: ""
    });
  };

  /**
   * filter the data on selection on dropdown
   * @param {*} data
   * @returns
   */
  getFilteredData = data => {
    const { colFilteredObj, sortByColKey } = this.state;
    const fData = orderBy(
      filterTableRows(data, colFilteredObj),
      x => x[sortByColKey],
      "desc"
    );

    return fData || [];
  };

  /**
   * update the colum filter
   * @param {*} key
   * @param {*} value
   * @param {*} filterType
   */
  updateColumnFilter = (key, value = "", filterType) => {
    const { colFilteredObj, selectedIds } = this.state;
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string"
      };
      key &&
        this.setState({
          colFilteredObj: colFilteredObj,
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    } else {
      key &&
        this.setState({
          colFilteredObj: [
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" }
          ],
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    }
  };

  /**
   * download ssrs report
   * @param {*} report
   * @param {*} type
   */
  downloadSSRSReport = (report, type = "excel") => {
    const {
      colFilteredObj,
      dataCenterMasterData,
      categoryMasterData,
      subCategoryMasterData,
      statusMasterData,
      sourceSystemMasterData
    } = this.state;
    const incidentCode =
      colFilteredObj.filter(f => f.keyName == "incidentCode")[0]?.value ||
      "All";
    const dataCenterName =
      colFilteredObj.filter(f => f.keyName == "dataCenterName")[0]?.value ||
      "All";
    const categoryName =
      colFilteredObj.filter(f => f.keyName == "categoryName")[0]?.value ||
      "All";
    const subCategoryName =
      colFilteredObj.filter(f => f.keyName == "subCategoryName")[0]?.value ||
      "All";
    const reportedBy =
      colFilteredObj.filter(f => f.keyName == "reportedBy")[0]?.value || "All";
    const status =
      colFilteredObj.filter(f => f.keyName == "incidentStatus")[0]?.value ||
      "All";

    // get source system selected value
    const sourceSystem =
      colFilteredObj.filter(f => f.keyName == "sourceSystem")[0]?.value ||
      "All";

    const incidentDateFilter = colFilteredObj.filter(
      f => f.keyName == "incidentDate"
    )[0]?.value;
    const createdDateFilter = colFilteredObj.filter(
      f => f.keyName == "createdDate"
    )[0]?.value;

    let incidentFrom = "IsNull=True";
    let incidentTo = "IsNull=True";
    let createdFromDate = "IsNull=True";
    let createdTo = "IsNull=True";

    if (incidentDateFilter && incidentDateFilter.length > 0) {
      [incidentFrom, incidentTo] = incidentDateFilter.split("-");
    }

    if (createdDateFilter && createdDateFilter.length > 0) {
      [createdFromDate, createdTo] = createdDateFilter.split("-");
    }
    const dateOffset = moment().utcOffset();

    let dataCenterId = [];
    let categoryId = [];
    let subCategoryId = [];
    let statusId = [];
    let sourceSystemId = [];

    if (dataCenterName !== "All") {
      dataCenterName.forEach(x => {
        if (x == "All") {
          dataCenterId = [];
          return;
        } else {
          dataCenterId.push(
            dataCenterMasterData.find(y => y.DataCenter === x)?.DataCenterId
          );
        }
      });
    }

    if (categoryName !== "All") {
      categoryName.forEach(x => {
        if (x == "All") {
          categoryId = [];
          return;
        } else {
          categoryId.push(
            categoryMasterData.find(y => y.categoryType === x)?.categoryTypeId
          );
        }
      });
    }

    if (subCategoryName !== "All") {
      subCategoryName.forEach(x => {
        if (x == "All") {
          subCategoryId = [];
          return;
        } else {
          subCategoryId.push(
            subCategoryMasterData.find(y => y.SubCategory === x)?.SubCategoryId
          );
        }
      });
    }

    if (status !== "All") {
      status.forEach(x => {
        if (x == "All") {
          statusId = [];
          return;
        } else {
          statusId.push(
            statusMasterData.find(y => y.IncidentStatus === x)?.IncidentStatusId
          );
        }
      });
    }

    // get source system id
    if (sourceSystem !== "All") {
      sourceSystem.forEach(x => {
        if (x == "All") {
          sourceSystemId = [];
          return;
        } else {
          sourceSystemId.push(
            sourceSystemMasterData.find(y => y.SourceSystem === x)
              ?.SourceSystemId
          );
        }
      });
    }

    const attachment =
      colFilteredObj
        .filter(f => f.keyName == "attachment")[0]
        ?.value.toString() || "All";
    const attachmentLength =
      attachment.split(",").length == 3 ? "All" : attachment;
    const param =
      "&IncidentCode=" +
      incidentCode +
      "&Attachment=" +
      attachmentLength +
      "&CategoryId=" +
      (categoryId.length === 0 ? "All" : categoryId.join(",")) +
      "&SubCategoryId=" +
      (subCategoryId.length === 0 ? "All" : subCategoryId.join(",")) +
      "&ReportedBy=" +
      (reportedBy == null || reportedBy == undefined ? "All" : reportedBy) +
      "&DataCenterId=" +
      (dataCenterId.length === 0 ? "All" : dataCenterId.join(",")) +
      (incidentFrom == "IsNull=True"
        ? "&IncidentFromDate:"
        : "&IncidentFromDate=") +
      incidentFrom +
      (incidentTo == "IsNull=True" ? "&IncidentToDate:" : "&IncidentToDate=") +
      incidentTo +
      (createdFromDate == "IsNull=True"
        ? "&CreatedFromDate:"
        : "&CreatedFromDate=") +
      createdFromDate +
      (createdTo == "IsNull=True" ? "&CreatedToDate:" : "&CreatedToDate=") +
      createdTo +
      "&DateOffset=" +
      dateOffset +
      "&IncidentStatusId=" +
      (statusId.length === 0 ? "All" : statusId.join(",")) +
      "&SourceSystemId=" +
      (sourceSystemId?.length === 0 ? "All" : sourceSystemId.join(","));
    switch (type) {
      case "pdf":
        downloadExcelReportByAPI(
          `${report.downloadLink}PDF${param}`,
          report.label,
          "application/pdf"
        );
        break;
      case "excel":
        downloadExcelReportByAPI(
          `${report.downloadLink}EXCELOPENXML${param}`,
          report.label
        );
        break;
    }
  };
  /**
   * view all data center data
   * @param {*} viewAll
   * @param {*} dataCenters
   * @param {*} title
   */
  handleViewAllDataCenter = (viewAll = false, dataCenters, title = "") => {
    this.setState({
      viewAllDataCenter: viewAll,
      selectedDataCenters: dataCenters,
      title
    });
  };

  /**
   * clear filter
   */
  clearFilter = () => {
    const { refreshFilteredObj } = this.state;
    this.setState({
      colFilteredObj: [],
      clearData: true,
      refreshFilteredObj: !refreshFilteredObj,
      sortByColKey: "",
      selectedIds: {}
    });
  };

  /**
   * set value of reason
   * @param {*} e
   */
  handleChange = e => {
    this.setState({
      reasonForDelete: e.target.value || ""
    });
  };

  /**
   * delete confirmation panel
   * @param {*} requestId
   */
  openDeleteConfirmationPanel = (isOpen, incidentId, propertyId) => {
    this.setState({
      incidentId: incidentId,
      propertyId: propertyId,
      isOpenDeleteConfirmationPanel: isOpen
    });
  };

  /**
   * delete hse observation record
   * @param {*} res
   */
  deleteSecurityIncident = res => {
    if (res == true) {
      const {
        incidentId,
        propertyId,
        reasonForDelete,
        getToolTip
      } = this.state;
      if (reasonForDelete && reasonForDelete?.trim().length > 0) {
        apiDelete({
          url:
            API_URL.securityIncident.DeleteSecurityIncident +
            "?incidentId=" +
            incidentId +
            "&propertyId=" +
            propertyId +
            "&reasonForDelete=" +
            reasonForDelete
        }).then(response => {
          response.success == false
            ? ShowToast(
                "Server Error: Unable to delete Security Incident.",
                toastType.ERROR,
                5000,
                500
              )
            : ShowToast(
                "Security Incident has been deleted successfully.",
                toastType.SUCCESS,
                5000,
                200
              );
          this.setState(
            {
              isOpenDeleteConfirmationPanel: false,
              reasonForDelete: false,
              incidentId: 0,
              propertyId: 0
            },
            () => {
              this.getIncidentList();
            }
          );
        });
      } else {
        ShowToast(
          getToolTipText(getToolTip, TOOLTIP_LABEL.REASON_FOR_DELETE) +
            " is required.",
          toastType.ERROR,
          5000,
          500
        );
      }
    } else {
      this.setState({
        isOpenDeleteConfirmationPanel: false,
        reasonForDelete: "",
        incidentId: 0,
        propertyId: 0
      });
    }
  };

  isEditIconVisible = () => {
    return IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );
  };

  isViewIconVisible = () => {
    return IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.VIEW
    );
  };

  isDeleteIconVisible = () => {
    return CheckPermission(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.FULL_ACCESS
    );
  };

  hasFullAccess = () => {
    return CheckPermission(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.FULL_ACCESS
    );
  };

  isSpEditIconVisible = () => {
    return IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_EVENT_NOTIFICATION,
      SECTIONS.ADD_EDIT
    );
  };

  isSpViewIconVisible = () => {
    return IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_EVENT_NOTIFICATION,
      SECTIONS.VIEW
    );
  };

  hasFullAccessSp = () => {
    return IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_EVENT_NOTIFICATION,
      SECTIONS.FULL_ACCESS
    );
  };

  render() {
    const {
      editableData,
      isShowColFilter,
      isOpenAddUpdate,
      urlIncidentId,
      colFilteredObj,
      incidentList,
      categoryMasterData,
      subCategoryMasterData,
      contributingFactorMasterData,
      dataCenterMasterData,
      statusMasterData,
      sourceSystemMasterData,
      isOpenDeleteConfirmationPanel,
      reasonForDelete,
      getToolTip,
      refreshFilteredObj,
      selectedDataCenters,
      pageNo,
      rowsPerPagination,
      clearData,
      selectedIds,
      keepFilterData,
      reload,
      selectedSource,
      viewAllDataCenter,
      title
    } = this.state;

    const addIncidentVisible = IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );

    const incidentFilterData = isShowColFilter
      ? this.getFilteredData(incidentList)
      : incidentList;

    const optionsListForCategory = uniqBy(
      convertIntoDDFormat(
        categoryMasterData || [],
        "categoryType",
        "categoryType"
      ),
      x => x.id
    );

    const optionsListForSubCategory = uniqBy(
      convertIntoDDFormat(
        subCategoryMasterData || [],
        "SubCategory",
        "SubCategory"
      ),
      x => x.id
    );

    const dataCenterData =  GetEnableProperty((dataCenterMasterData || []), SECTIONS.SECURITY_AND_OPERATION, "DataCenterId");

    const optionsListForDataCenter = uniqBy(
      convertIntoDDFormat(
        dataCenterData || [],
        "DataCenter",
        "DataCenter"
      ),
      x => x.id
    );

  
    const optionsListForStatus = uniqBy(
      convertIntoDDFormat(
        statusMasterData || [],
        "IncidentStatus",
        "IncidentStatus",
      ),
      x => x.id
    );

    // to get source system master data
    const optionsListForSourceSystem = uniqBy(
      convertIntoDDFormat(
        sourceSystemMasterData || [],
        "SourceSystem",
        "SourceSystem"
      ),
      x => x.id
    );
    localStorage.setItem("IsInEditMode", 0);
    return (
      <div className={"col-xs-12"}>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <div className={"requests-wrapper"}>
              <div className={"requests-breadcrumb-wrapper"}>
                <div className={"requests-breadcrumb"}>
                  {"HOME | "}
                  <span>{"Security Incident"}</span>
                  {isOpenAddUpdate && editableData == "" && urlIncidentId == ""
                    ? " | Create Incident"
                    : ""}
                  {addIncidentVisible === false &&
                  editableData &&
                  editableData != ""
                    ? " | View Security Incident"
                    : (editableData && editableData != "") ||
                      urlIncidentId !== ""
                    ? " | Edit Incident"
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isOpenAddUpdate ? (
          categoryMasterData &&
          subCategoryMasterData &&
          contributingFactorMasterData &&
          dataCenterMasterData && (
            <AddUpdateIncident
              toolTip={getToolTip}
              statusMasterData={statusMasterData}
              categoryMasterData={categoryMasterData}
              subCategoryMasterData={subCategoryMasterData}
              contributingFactorMasterData={contributingFactorMasterData}
              dataCenterMasterData={dataCenterMasterData}
              incidentId={
                editableData ? editableData.incidentId : urlIncidentId
              }
              propertyId={editableData ? editableData.propertyId : 0}
              setStateVal={this.onEditClicked}
              onSave={this.onSave}
              refreshIncident={this.refreshIncident}
            />
          )
        ) : (
          <>
            <div className={"row"}>
              <div className={"col-xs-10"} style={{ display: "flex" }}>
                {addIncidentVisible && (
                  <Button
                    variant={"contained"}
                    size={"small"}
                    onClick={() => this.onAddButtonClicked(true)}
                    style={{ height: "32px" }}
                  >
                    {"Create Incident\r"}
                  </Button>
                )}
                <FormControlLabel
                  className={"show-filter"}
                  control={
                    <Checkbox
                      id={"filterCompletedOrCancelled"}
                      color={"primary"}
                      defaultValue={isShowColFilter}
                      checked={isShowColFilter}
                      onChange={event =>
                        this.setState({
                          isShowColFilter: event.target.checked,
                          colFilteredObj: [],
                          clearData: true,
                          refreshFilteredObj: !refreshFilteredObj,
                          sortByColKey: "",
                          selectedIds: {}
                        })}
                    />
                  }
                  label={"Show Filters"}
                />
                <DownloadSSRSPopUp
                  buttonLabel={"Print"}
                  dataTip={getToolTipText(getToolTip, TOOLTIP_LABEL.DOWNLOAD)}
                  reportList={[
                    {
                      label: "Security Incident List",
                      id: 1,
                      pdfDownload: true,
                      excelDownload: true,
                      downloadLink: Security_Incident_List
                    }
                  ]}
                  downloadBtnLabel={"Download"}
                  downloadReport={this.downloadSSRSReport}
                />
                <Tooltip
                  title={getToolTipText(getToolTip, TOOLTIP_LABEL.CLEAR_FILTER)}
                  placement={"bottom"}
                >
                  <img
                    className={"icons"}
                    src={FilterOff}
                    alt={"logo"}
                    onClick={() => {
                      this.clearFilter();
                    }}
                  />
                </Tooltip>
              </div>
              <div className={"col-xs-2 end-xs"}>
                <Tooltip
                  title={getToolTipText(getToolTip, TOOLTIP_LABEL.REFRESH)}
                  placement={"bottom"}
                >
                  <IconButton size={"small"} onClick={() => this.resetPage()}>
                    <RefreshIcon
                      style={{
                        fill: "#365E7E",
                        marginTop: "7px",
                        width: "28px",
                        height: "30px"
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <div className={"row content"} />
            <div className={"request-list-table-div"}>
              {incidentFilterData ? (
                <table
                  className={"request-list-table"}
                  style={{ fontWeight: "200 !important" }}
                >
                  <thead>
                    <tr
                      className={"blue-cust-title"}
                      style={{ borderTop: "3px solid #FFFFFF" }}
                    >
                      <th
                        colSpan={13}
                        style={{
                          fontSize: "15px",
                          textAlign: "center",
                          lineHeight: "25px"
                        }}
                      >
                        {"Security Incident\r"}
                      </th>
                    </tr>
                    <TableHeaderWithFilter
                      clearData={clearData}
                      refreshFilteredObj={refreshFilteredObj}
                      selectedId={selectedIds}
                      reload={reload}
                      keepFilterData={keepFilterData}
                      selectedSource={selectedSource}
                      columnData={[
                        {
                          headerClass: "w-15",
                          colName: "Incident #",
                          keyName: "incidentCode"
                        },
                        {
                          headerClass: "w-20",
                          colName: "Incident Date",
                          keyName: "incidentDate",
                          filterType: "dateRange"
                        },
                        {
                          headerClass: "w-10",
                          colName: "Data Center",
                          keyName: "dataCenterName",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.dataCenterName,
                          optionsList: optionsListForDataCenter
                        },
                        {
                          headerClass: "w-15",
                          colName: "Category",
                          keyName: "categoryName",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.categoryName,
                          optionsList: optionsListForCategory
                        },
                        {
                          headerClass: "w-15",
                          colName: "Sub Category",
                          filterType: "multiSelect",
                          keyName: "subCategoryName",
                          selectedIds: colFilteredObj.subCategoryName,
                          optionsList: optionsListForSubCategory
                        },

                        {
                          headerClass: "w-15",
                          colName: "Created Date",
                          keyName: "createdDate",
                          filterType: "dateRange"
                        },
                        {
                          headerClass: "w-10",
                          colName: "Reported By",
                          keyName: "reportedBy"
                        },
                        {
                          headerClass: "w-5",
                          width: "68px",
                          colName: "Status",
                          keyName: "incidentStatus",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.incidentStatus,
                          optionsList: optionsListForStatus
                        },
                        {
                          headerClass: "w-5",
                          width: "75px",
                          colName: "Attachment",
                          keyName: "attachment",
                          filterType: "multiSelect",
                          optionsList: [
                            { id: "No", value: "No" },
                            { id: "Yes", value: "Yes" }
                          ]
                        },
                        {
                          headerClass: "w-10",
                          width: "68px",
                          colName: "Source System",
                          keyName: "sourceSystem",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.sourceSystem,
                          optionsList: optionsListForSourceSystem
                        },
                        {
                          headerClass: "w-20",
                          colName: "Action",
                          isHideFilter: true
                        }
                      ]}
                      isShowFilter={isShowColFilter}
                      onChangeFilter={this.updateColumnFilter}
                    />
                  </thead>

                  <tbody>
                    {incidentFilterData && incidentFilterData.length > 0 ? (
                      (
                        (rowsPerPagination > 0
                          ? incidentFilterData.slice(
                              pageNo * rowsPerPagination,
                              pageNo * rowsPerPagination + rowsPerPagination
                            )
                          : incidentFilterData) || []
                      ).map((item, index) => (
                        <tr key={"observation" + index}>
                          <td>
                            {item.incidentCode == null
                              ? "-"
                              : item.incidentCode}
                          </td>

                          <td>
                            {item.incidentDate == null
                              ? "-"
                              : moment(item.incidentDate).format(
                                  "MM/DD/YYYY hh:mm A"
                                )}
                          </td>
                          <td>
                            {item.dataCenterName == null
                              ? "-"
                              : item.dataCenterName}
                          </td>
                          <td>
                            {item.categoryName == null
                              ? "-"
                              : item.categoryName}
                          </td>

                          <td style={{ textAlign: "left" }}>
                            {item.subCategoryName == null
                              ? "-"
                              : item.subCategoryName}
                          </td>
                          <td>
                            {moment(item.createdDate).format("MM/DD/YYYY")}
                          </td>
                          <td>
                            {item.reportedBy == null ? "-" : item.reportedBy}
                          </td>
                          <td>
                            {item.incidentStatus == null
                              ? "-"
                              : item.incidentStatus}
                          </td>
                          <td>
                            {item.attachment == null ? "-" : item.attachment}
                          </td>
                          <td>
                            {item.sourceSystem == null
                              ? "-"
                              : item.sourceSystem}
                          </td>
                          {item.requestStatusId > REQUEST_STATUS.DRAFT &&
                          !this.isEditIconVisible() ? (
                            <td>
                              <span style={{ display: "flex" }}>
                                <Tooltip
                                  title={getToolTipText(
                                    getToolTip,
                                    TOOLTIP_LABEL.VIEW
                                  )}
                                  placement={"bottom"}
                                >
                                  <IconButton
                                    size={"small"}
                                    onClick={() =>
                                      this.onEditClicked(true, item)}
                                  >
                                    <VisibilityIcon
                                      size={"small"}
                                      fontSize={"small"}
                                    />
                                  </IconButton>
                                </Tooltip>
                                {item.sourceSystemId === DCOP_SOURCE_SYSTEM &&
                                  IsAdmin() && (
                                    <Tooltip
                                      title={getToolTipText(
                                        getToolTip?.filter(
                                          x => x.LabelType === "Tooltip"
                                        ) || [],
                                        TOOLTIP_LABEL.DELETE
                                      )}
                                      placement={"bottom"}
                                    >
                                      <IconButton
                                        size={"small"}
                                        onClick={() =>
                                          this.openDeleteConfirmationPanel(
                                            true,
                                            item.incidentId,
                                            item.propertyId
                                          )}
                                      >
                                        <DeleteIcon
                                          size={"small"}
                                          fontSize={"small"}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </span>
                            </td>
                          ) : (
                            <td>
                              <span style={{ display: "flex" }}>
                                <Tooltip
                                  title={
                                    (this.isEditIconVisible() &&
                                      item.sourceSystemId ===
                                        DCOP_SOURCE_SYSTEM) ||
                                    (this.isSpEditIconVisible() &&
                                      item.sourceSystemId !==
                                        DCOP_SOURCE_SYSTEM)
                                      ? getToolTipText(
                                          getToolTip,
                                          TOOLTIP_LABEL.EDIT
                                        )
                                      : getToolTipText(
                                          getToolTip,
                                          TOOLTIP_LABEL.VIEW
                                        )
                                  }
                                >
                                  <IconButton
                                    size={"small"}
                                    onClick={() =>
                                      this.onEditClicked(true, item)}
                                  >
                                    {(this.isEditIconVisible() &&
                                      item.sourceSystemId ===
                                        DCOP_SOURCE_SYSTEM) ||
                                    (this.isSpEditIconVisible() &&
                                      item.sourceSystemId !==
                                        DCOP_SOURCE_SYSTEM) ? (
                                      <EditIcon
                                        size={"small"}
                                        fontSize={"small"}
                                      />
                                    ) : (
                                      <VisibilityIcon
                                        fontSize={"small"}
                                        size={"small"}
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  </IconButton>
                                </Tooltip>
                                {item.sourceSystemId === DCOP_SOURCE_SYSTEM &&
                                  this.isDeleteIconVisible() && (
                                    <Tooltip
                                      title={getToolTipText(
                                        getToolTip?.filter(
                                          x => x.LabelType === "Tooltip"
                                        ) || [],
                                        TOOLTIP_LABEL.DELETE
                                      )}
                                      placement={"bottom"}
                                    >
                                      <IconButton
                                        size={"small"}
                                        onClick={() =>
                                          this.openDeleteConfirmationPanel(
                                            true,
                                            item.incidentId,
                                            item.propertyId
                                          )}
                                      >
                                        <DeleteIcon
                                          size={"small"}
                                          fontSize={"small"}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </span>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td style={{ textAlign: "center" }} colSpan={9}>
                          {"No data available\r"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                ""
              )}
            </div>
            {incidentFilterData && incidentFilterData.length > 0 && (
              <div className={"paginationContainer"}>
                <PaginationControlled
                  tableLength={incidentFilterData.length}
                  updateRowCount={this.updateRowCount}
                  pageNo={pageNo}
                  rowsPerPagination={rowsPerPagination}
                />
              </div>
            )}
          </>
        )}
        <Dialog
          open={viewAllDataCenter || false}
          onClose={() => this.handleViewAllDataCenter(false, "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {title}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"start"}
                color={"inherit"}
                onClick={() => this.handleViewAllDataCenter(false, "")}
                aria-label={"close"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedDataCenters &&
              sortArray(removeDuplicates(selectedDataCenters.split(",")))?.map(
                (obj, index) => (
                  <Chip
                    className={"chip"}
                    key={"chip" + index + "c"}
                    label={obj}
                    style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                  />
                )
              )}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewAllDataCenter(false, "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>

        <ConfirmDialog
          size={"sm"}
          IsOpen={isOpenDeleteConfirmationPanel}
          Message={getToolTipText(
            getToolTip?.filter(x => x.LabelType === "Popup Message") || [],
            TOOLTIP_LABEL.DELETE
          )}
          OnHandelClick={this.deleteSecurityIncident}
          AgreeText={getToolTipText(getToolTip, TOOLTIP_LABEL.YES)}
          DisAgreeText={getToolTipText(getToolTip, TOOLTIP_LABEL.NO)}
          deleteConfig={{
            id: "reasonForDelete",
            value: reasonForDelete,
            isDeleteReason: true,
            action: this.handleChange,
            name: getToolTipText(getToolTip, TOOLTIP_LABEL.REASON_FOR_DELETE)
          }}
        />
      </div>
    );
  }
}

export default SecurityIncidentTable;
